import { Button } from "antd"
import React from "react"
import './style.css'

const CustomButton = (props) => {
	const {
		type,
		children,
		size,
		fontSize,
		className,
		spinning = false,
		...otherProps
	} = props

	const colorType = type ?? "green"
	const sizeType = size ?? "medium"

	return (
		<Button
			{...otherProps}
			className={`custom-button button_ao ${colorType} ${sizeType} ${className ?? ""}`}
		>
			{children}
		</Button>
	)
}

export default CustomButton